import VehiclesError from './VehiclesError.js'

export default class GetBodyTypeInfoVehiclesError extends VehiclesError {}
